const host = window.location.host;

export const config = {
  API_URL: host.includes('localhost') ? 'http://127.0.0.1:8000' : 'https://api.learnala.org',
};
